import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import {
  Button,
  Grid,
  Typography,
} from '@material-ui/core';
import {
  Save as SaveIcon,
  MoreVert as MoreVertIcon,
} from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';

import * as recoveryPriceService from 'services/recoveryPrices';
import * as projectService from 'services/projects';
import { Dashboard as DashboardLayout } from 'layouts';
import { FormField2 as Field, CommonPanel, TrialHandler, LicenceRequestForm, canAccess as canAccessUtil } from 'components';
import { toast, getQueryVariable, getCurrentAccount } from 'utils/helpers';
import api from 'utils/api';
import { EDU_MODE } from 'utils/config';

const SERVICE_CODE = 'ntk';
const SERVICE_CODE_DB = 'BIMGates_NTK_BA';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '15px',
    padding: theme.spacing(4),
    // maxWidth: '1200px',
  },
  titleCoefficients: {
    fontSize: '9px',
    padding: '0px 8px 2px',
  },
}));

const RecoveryPrice = (props) => {
  const { projectId, recoveryPriceId } = useParams();
  const history = useHistory();
  const classes = useStyles();
  const [record, setRecord] = useState(null);
  const [project, setProject] = useState(null);
  const [canAccessService, setCanAccessService] = useState(false);
  const [isTrial, setIsTrial] = useState(!!getQueryVariable('trial'));
  const [showTrialMessage, setShowTrialMessage] = useState(getCurrentAccount().trialServices.includes(SERVICE_CODE));
  const { t } = useTranslation();
  const isNew = !record?._id;

  const fetchProject = async (projectId) => {
    try {
      const data = await projectService.show(projectId);
      setProject(data);
    } catch (err) {
      console.error(err);
      toast(t('Klaida įkeliant įrašą'), 'error');
    }
  }

  const checkLicence = async () => {
    try {
      const response = await api.post(`/licences/licence-valid`, { service: SERVICE_CODE_DB });
      setCanAccessService(response.data.validLicence);
      return response.data.validLicence;
    } catch (err) {
      console.error(err);
      toast(t('Klaida įkeliant konfigūraciją'), 'error');
    }
  }

  useEffect(() => {
    if (isTrial) return;

    if (!record?._id && recoveryPriceId) fetchRecord(recoveryPriceId);
    checkLicence().then(canAccess => {
      if (canAccess) fetchProject(projectId)
    });
  }, []);

  useEffect(() => {
    if (record == null && project?.title) {
      setRecord({ ...record, title: project?.title });
    }
  }, [project])

  const handleRecordChange = ({ name, value }, submitAfter = false) => {
    const newRecord = {
      ...record,
      [name]: value,
    };

    setRecord(newRecord);

    if (submitAfter) handleSubmit(newRecord, submitAfter);
  }

  const handleSubmit = async (data = null, hideToast = false) => {
    try {
      const payload = _.omit(data || record, 'items');
      payload.project = projectId;

      if (!recoveryPriceId) {
        if (!payload?.title) payload.title = project?.title;
        if (!payload?.pricing) {
          payload.totals = { totalRevisedPrice: 0 };
        }
        const { _id } = await recoveryPriceService.create(payload);

        if (!hideToast) toast(t('Atkuriamosios vertės skaičiavimas sukurtas'), 'success');
        history.push(`/recovery-price/${_id}`);
      }
    } catch (err) {
      console.error(err);
      toast(t('Nepavyko išsaugoti'), 'error');
    }
  };

  const renderTrial = () => {

    return (
      <TrialHandler
        service="ntk"
      />
    )
  }

  const renderTrialMessage = () => {

    return EDU_MODE ? null : (
      <div style={{ margin: 10 }}>
        <Alert
          variant="filled"
          severity="info"
        // onClose={() => this.setState({ showTrialMessage: false })}
        >
          {t('Jūs naudojate bandomąją (laikinai nemokamą) paslaugos versiją.')}
        </Alert>
      </div>
    )
  }

  const renderLicenceRequest = () => {

    return (
      <LicenceRequestForm
        serviceCode={SERVICE_CODE}
      />
    )
  }

  return (
    <>
      <DashboardLayout
        breadcrumbs={[
          { title: t('Projektai'), to: '/projects/' },
          { title: project?.title || '-', to: `/projects/${projectId}/dashboard` },
          { title: t('Atkuriamosios vertės skaičiavimai') },
          {
            title: t('Naujas skaičiavimas'),
            style: {
              whiteSpace: 'pre-wrap',
            }
          },
        ]}
        beforeMainContent={!isTrial && showTrialMessage && renderTrialMessage()}
      >
        <div className={classes.root} style={{ paddingTop: 12 }}>

          {!isTrial ? canAccessService ? (
            <CommonPanel>
              {isNew && (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Field name="title" onChange={handleRecordChange} value={record?.title} label={t('Skaičiavimų objekto pavadinimas')} shrink />
                    <Typography variant="body1">
                      {t('Įveskite naujo skaičiavimų objekto pavadinimą ir išsaugokite, kad galėtumėte pradėti skaičiavimus')}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      startIcon={<SaveIcon />}
                      variant="contained"
                      color="primary"
                      onClick={() => handleSubmit()}
                      style={{ marginTop: 15 }}
                      disabled={!record?.title}
                    >
                      Išsaugoti
                    </Button>
                  </Grid>
                </Grid>
              )}
            </CommonPanel>
          ) : renderLicenceRequest() : renderTrial()}
        </div >

      </DashboardLayout >
    </>
  );
};

export default RecoveryPrice;